import {
  dateFormatter, dateTimeFormatter,
  getLegalEntityName,
  localeFormatter, orderServiceFormatter, smevCheckWithContentFormatter,
  statusFormatter,
  userPositionFormatter,
} from '../../../utils/formatters';

export const applicationColumns = [
  {
    dataField: 'created_at',
    text: 'Дата создания',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'applicant',
    text: 'Заявитель',
    headerClassName: 'user-column',
    formatter: getLegalEntityName,
  },
  {
    dataField: 'mais_egu_id',
    text: 'Номер обращения',
    headerClassName: 'number-column',
    formatter: (id, item) => smevCheckWithContentFormatter(id || 'Номер не указан', item?.checks_status || ''),
  },
  {
    dataField: 'apply_method',
    text: 'Способ подачи',
    headerClassName: 'apply-method-column',
    formatter: a => localeFormatter('apply.method.type', a),
  },
  {
    dataField: 'decision_deadline_date',
    text: 'Дата планового закрытия',
    formatter: dateFormatter,
    headerClassName: 'created-at',
  },
  {
    dataField: 'status',
    text: 'Статус обращения',
    headerClassName: 'status-column',
    formatter: a => statusFormatter(a),
  },
  {
    dataField: 'updated_at',
    text: 'Дата установки статуса',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'executor',
    text: 'Исполнитель',
    headerClassName: 'user-column',
    formatter: userPositionFormatter,
  },
];

export const applicationAdditionalColumns = [
  {
    dataField: 'procedure_label',
    text: 'Наименование услуги',
    headerClassName: 'procedure-name-column',
    sortField: 'procedure',
  },
  {
    dataField: 'decided_at',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'consider_apply_date',
    headerClassName: 'created-at',
    formatter: dateFormatter,
  },
  {
    dataField: 'applied_at',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'number',
    text: 'Номер разрешения',
    headerClassName: 'procedure-name-column',
  },
  {
    dataField: 'document_submission_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('document.submission.type', a) : null),
  },
  {
    dataField: 'procedure_conducting_authority',
    headerClassName: 'procedure-name-column',
  },
  {
    dataField: 'notification_violation_date',
    headerClassName: 'procedure-name-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'delivery_method_extracts_from_register',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('delivery.method.type', a) : null),
  },
  {
    dataField: 'delivery_method_notification',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('delivery.method.type', a) : null),
  },
  {
    dataField: 'notification_method',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('notification.method.type', a) : null),
  },
  {
    dataField: 'applicant',
    text: 'legal_entity_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('user.type', a.legal_entity_type) : null),
    sortField: 'applicant.legal_entity_type',
  },
  {
    dataField: 'applicant',
    text: 'last_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.last_name ? a.last_name : ''),
    sortField: 'applicant.last_name',
  },
  {
    dataField: 'applicant',
    text: 'first_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.first_name ? a.first_name : ''),
    sortField: 'applicant.first_name',
  },
  {
    dataField: 'applicant',
    text: 'middle_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.middle_name ? a.middle_name : ''),
    sortField: 'applicant.middle_name',
  },
  {
    dataField: 'applicant',
    text: 'birth_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.birth_date ? dateFormatter(a.birth_date) : ''),
    sortField: 'applicant.birth_date',
  },
  {
    dataField: 'applicant',
    text: 'gender',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('gender', a.gender) : ''),
    sortField: 'applicant.gender',
  },
  {
    dataField: 'applicant',
    text: 'citizenship',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('citizenship.type', a.citizenship) : ''),
    sortField: 'applicant.citizenship',
  },
  {
    dataField: 'applicant',
    text: 'registration_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('registration.type', a.registration_type) : ''),
    sortField: 'applicant.registration_type',
  },
  {
    dataField: 'applicant',
    text: 'place_of_birth',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.place_of_birth ? a.place_of_birth : ''),
    sortField: 'applicant.place_of_birth',
  },
  {
    dataField: 'applicant',
    text: 'snils',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.snils ? a.snils : ''),
    sortField: 'applicant.snils',
  },
  {
    dataField: 'applicant',
    text: 'inn',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.inn ? a.inn : ''),
    sortField: 'applicant.inn',
  },
  {
    dataField: 'applicant',
    text: 'phone',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.phone ? a.phone : ''),
    sortField: 'applicant.phone',
  },
  {
    dataField: 'applicant',
    text: 'email',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.email : ''),
    sortField: 'applicant.email',
  },
  {
    dataField: 'applicant',
    text: 'identity_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('identity.type', a.identity_type) : null),
    sortField: 'applicant.identity_type',
  },
  {
    dataField: 'applicant',
    text: 'identity_series',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.identity_series : ''),
    sortField: 'applicant.identity_series',
  },
  {
    dataField: 'applicant',
    text: 'identity_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.identity_number : ''),
    sortField: 'applicant.identity_number',
  },
  {
    dataField: 'applicant',
    text: 'identity_issue_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.identity_issue_date) : null),
    sortField: 'applicant.identity_issue_date',
  },
  {
    dataField: 'applicant',
    text: 'identity_issuer',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.identity_issuer : ''),
    sortField: 'applicant.identity_issuer',
  },
  {
    dataField: 'applicant',
    text: 'address',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.address : ''),
    sortField: 'applicant.address',
  },
  {
    dataField: 'applicant',
    text: 'commercial_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.commercial_name : ''),
    sortField: 'applicant.commercial_name',
  },
  {
    dataField: 'applicant',
    text: 'logo_files',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.logo_files : ''),
    sortField: 'applicant.logo_files',
  },
  {
    dataField: 'applicant',
    text: 'short_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.short_name : ''),
    sortField: 'applicant.short_name',
  },
  {
    dataField: 'applicant',
    text: 'full_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.full_name : ''),
    sortField: 'applicant.full_name',
  },
  {
    dataField: 'applicant',
    text: 'legal_address',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.legal_address : ''),
    sortField: 'applicant.legal_address',
  },
  {
    dataField: 'applicant',
    text: 'ogrn',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.ogrn : ''),
    sortField: 'applicant.ogrn',
  },

  // {
  //   dataField: 'applicant',
  //   text: 'logo_files',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.logo_files : ''),
  // },
  {
    dataField: 'applicant',
    text: 'legal_entity_form',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.legal_entity_form : ''),
    sortField: 'applicant.legal_entity_form',
  },
  {
    dataField: 'representative',
    text: 'representative.document_of_authority',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.document_of_authority : ''),
    sortField: 'representative.document_of_authority',
  },
  {
    dataField: 'representative',
    text: 'representative.document_of_authority_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.document_of_authority_number : ''),
    sortField: 'representative.document_of_authority_number',
  },
  {
    dataField: 'representative',
    text: 'representative.document_of_authority_issue_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.document_of_authority_issue_date) : ''),
    sortField: 'representative.document_of_authority_issue_date',
  },
  {
    dataField: 'representative',
    text: 'representative.document_of_authority_expiration_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.document_of_authority_expiration_date) : ''),
    sortField: 'representative.document_of_authority_expiration_date',
  },
  {
    dataField: 'representative',
    text: 'representative.last_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.last_name : ''),
    sortField: 'representative.last_name',
  },
  {
    dataField: 'representative',
    text: 'representative.first_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.first_name : ''),
    sortField: 'representative.first_name',
  },
  {
    dataField: 'representative',
    text: 'representative.middle_name',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.middle_name : ''),
    sortField: 'representative.middle_name',
  },
  {
    dataField: 'representative',
    text: 'representative.birth_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.birth_date) : ''),
    sortField: 'representative.birth_date',
  },
  {
    dataField: 'representative',
    text: 'representative.gender',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('gender', a.gender) : ''),
    sortField: 'representative.gender',
  },
  {
    dataField: 'representative',
    text: 'representative.citizenship',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('citizenship.type', a.citizenship) : ''),
    sortField: 'representative.citizenship',
  },
  // {
  //   dataField: 'representative',
  //   text: 'representative.registration_type',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => a => (a ? localeFormatter('registration.type', a.registration_type) : ''),
  // },
  {
    dataField: 'representative',
    text: 'representative.place_of_birth',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.place_of_birth : ''),
    sortField: 'representative.place_of_birth',
  },
  // {
  //   dataField: 'representative',
  //   text: 'representative.snils',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.snils : ''),
  // },
  // {
  //   dataField: 'representative',
  //   text: 'representative.inn',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.inn : ''),
  // },
  {
    dataField: 'representative',
    text: 'representative.phone',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.phone : ''),
    sortField: 'representative.phone',
  },
  {
    dataField: 'representative',
    text: 'representative.email',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.email : ''),
    sortField: 'representative.email',
  },
  {
    dataField: 'representative',
    text: 'representative.identity_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('identity.type', a.identity_type) : ''),
    sortField: 'representative.identity_type',
  },
  {
    dataField: 'representative',
    text: 'representative.identity_series',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.identity_series : ''),
    sortField: 'representative.identity_series',
  },
  {
    dataField: 'representative',
    text: 'representative.identity_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.identity_number : ''),
    sortField: 'representative.identity_number',
  },
  {
    dataField: 'representative',
    text: 'representative.identity_issue_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.identity_issue_date) : ''),
    sortField: 'representative.identity_issue_date',
  },
  {
    dataField: 'representative',
    text: 'representative.identity_issuer',
    headerClassName: 'procedure-name-column',
    sortField: 'representative.identity_issuer',
    formatter: a => (a ? a.identity_issuer : ''),
  },
  {
    dataField: 'representative',
    text: 'representative.address',
    headerClassName: 'procedure-name-column',
    sortField: 'representative.address',
    formatter: a => (a ? a.address : ''),
  },
  {
    dataField: 'application_carrier',
    text: 'permission_grant_period',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.permission_grant_period : ''),
    sortField: 'application_carrier.permission_grant_period',
  },
  {
    dataField: 'application_carrier',
    text: 'expiration_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.expiration_date) : ''),
    sortField: 'application_carrier.expiration_date',
  },
  // {
  //   dataField: 'insurance',
  //   text: 'insurer',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.insurer : ''),
  // },
  // {
  //   dataField: 'insurance',
  //   text: 'insurance_contract_series',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.insurance_contract_series : ''),
  // },
  // {
  //   dataField: 'insurance',
  //   text: 'insurance_contract_number',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.insurance_contract_number : ''),
  // },
  // {
  //   dataField: 'insurance',
  //   text: 'insurance_contract_effective_date',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? dateFormatter(a.insurance_contract_effective_date) : ''),
  // },
  // {
  //   dataField: 'insurance',
  //   text: 'insurance_contract_expiration_date',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? dateFormatter(a.insurance_contract_expiration_date) : ''),
  // },

  // {
  //   dataField: 'application_carrier',
  //   text: 'medical_examination_address',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.medical_examination_address : ''),
  // },
  // {
  //   dataField: 'application_vehicle',
  //   text: 'tech_control_address',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.tech_control_address : ''),
  // },
];

export const vehicleColumns = [
  {
    dataField: 'application_vehicle',
    text: 'vehicle_brand',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_brand : ''),
    sortField: 'application_vehicle.vehicle_brand',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_model',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_model : ''),
    sortField: 'application_vehicle.vehicle_model',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_year',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_year : ''),
    sortField: 'application_vehicle.vehicle_year',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_color',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_color : ''),
    sortField: 'application_vehicle.vehicle_color',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_lpn',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_lpn : ''),
    sortField: 'application_vehicle.vehicle_lpn',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_vin',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_vin : ''),
    sortField: 'application_vehicle.vehicle_vin',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_registration_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.vehicle_registration_number : ''),
    sortField: 'application_vehicle.vehicle_registration_number',
  },
  {
    dataField: 'application_vehicle',
    text: 'vehicle_registration_issue_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.vehicle_registration_issue_date) : ''),
    sortField: 'application_vehicle.vehicle_registration_issue_date',
  },
  {
    dataField: 'application_vehicle',
    text: 'ecology_class_short',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('ecology-class', a.ecology_class) : ''),
    sortField: 'application_vehicle.ecology_class',
  },
  {
    dataField: 'application_vehicle',
    text: 'has_special_lifting_device',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.has_special_lifting_device ? 'Есть' : 'Нет' : ''),
    sortField: 'application_vehicle.has_special_lifting_device',
  },
  {
    dataField: 'application_vehicle',
    text: 'ownership_type',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? localeFormatter('ownership.type', a.ownership_type) : ''),
    sortField: 'application_vehicle.ownership_type',
  },
  {
    dataField: 'application_vehicle',
    text: 'ownership_contract_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.ownership_contract_number : ''),
    sortField: 'application_vehicle.ownership_contract_number',
  },
  {
    dataField: 'application_vehicle',
    text: 'ownership_contract_effective_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.ownership_contract_effective_date) : ''),
    sortField: 'application_vehicle.ownership_contract_effective_date',
  },
  {
    dataField: 'application_vehicle',
    text: 'ownership_contract_expiration_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.ownership_contract_expiration_date) : ''),
    sortField: 'application_vehicle.ownership_contract_expiration_date',
  },
];

export const carrierColumns = [
  // {
  //   dataField: 'osgop_insurance',
  //   text: 'osgop_insurer',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.insurer : ''),
  // },
  // {
  //   dataField: 'osgop_insurance',
  //   text: 'osgop_insurance_contract_number',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? a.insurance_contract_number : ''),
  // },
  // {
  //   dataField: 'osgop_insurance',
  //   text: 'osgop_insurance_contract_effective_date',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? dateFormatter(a.insurance_contract_effective_date) : ''),
  // },
  // {
  //   dataField: 'osgop_insurance',
  //   text: 'osgop_insurance_contract_expiration_date',
  //   headerClassName: 'procedure-name-column',
  //   formatter: a => (a ? dateFormatter(a.insurance_contract_expiration_date) : ''),
  // },

  {
    dataField: 'application_carrier',
    text: 'has_employees',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.has_employees ? 'Да' : 'Нет'),
    sortField: 'application_carrier.has_employees',
  },
  {
    dataField: 'application_carrier',
    text: 'driver_license_series',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.driver_license_series : ''),
    sortField: 'application_carrier.driver_license_series',
  },
  {
    dataField: 'application_carrier',
    text: 'driver_license_number',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.driver_license_number : ''),
    sortField: 'application_carrier.driver_license_number',
  },
  {
    dataField: 'application_carrier',
    text: 'driver_license_issue_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.driver_license_issue_date) : ''),
    sortField: 'application_carrier.driver_license_issue_date',
  },
  {
    dataField: 'application_carrier',
    text: 'driver_license_expiration_date',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? dateFormatter(a.driver_license_expiration_date) : ''),
    sortField: 'application_carrier.driver_license_expiration_date',
  },
  {
    dataField: 'application_carrier',
    text: 'СЗЛТ включить перевозчику',
    headerClassName: 'order-service-formatter',
    formatter: a => {
      if (!a || !a.order_services_attach || !a.order_services_attach.length) { return ''; }
      return orderServiceFormatter(a.order_services_attach);
    },
    disableSort: true,
  },
  {
    dataField: 'application_carrier',
    text: 'СЗЛТ исключить от перевозчика',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.order_service_numbers_detach ? a.order_service_numbers_detach.join(', ') : ''),
    disableSort: true,
  },
  {
    dataField: 'application_carrier',
    text: 'vehicle_numbers_attach',
    headerClassName: 'procedure-name-column',
    formatter: a => (a && a.vehicle_numbers_attach ? a.vehicle_numbers_attach.join(', ') : ''),
    sortField: 'application_carrier.vehicle_numbers_attach',
    disableSort: true,
  },
  {
    dataField: 'application_carrier',
    text: 'vehicle_numbers_detach',
    headerClassName: 'procedure-name-column',
    formatter: a => (a?.vehicle_numbers_detach?.length ? a.vehicle_numbers_detach.join(', ') : ''),
    sortField: 'application_carrier.vehicle_numbers_detach',
    disableSort: true,
  },
  {
    dataField: 'application_carrier',
    text: 'Наличие судимости',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.criminal_record_note : ''),
    sortField: 'application_carrier.criminal_record_note',
  },
];

export const szltColumns = [
  {
    dataField: 'application_order_service',
    text: 'web_site',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.web_site : ''),
    sortField: 'application_order_service.web_site',
  },
  {
    dataField: 'application_order_service',
    text: 'order_receiving_methods',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.order_receiving_methods : ''),
    sortField: 'application_order_service.order_receiving_methods',
  },
  {
    dataField: 'application_order_service',
    text: 'software_names',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.software_names : ''),
    sortField: 'application_order_service.software_names',
  },
  {
    dataField: 'application_order_service',
    text: 'database_address',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.database_address : ''),
    sortField: 'application_order_service.database_address',
  },
  {
    dataField: 'application_order_service',
    text: 'server_address',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.server_address : ''),
    sortField: 'application_order_service.server_address',
  },
  {
    dataField: 'applicant',
    text: 'Адрес размещения филиала в СПб',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.office_address : ''),
    sortField: 'applicant.office_address',
  },
  {
    dataField: 'applicant',
    text: 'Номер телефона филиала в СПб ',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.office_phone : ''),
    sortField: 'applicant.office_phone',
  },
  {
    dataField: 'applicant',
    text: 'Электронная почта филиала в СПб',
    headerClassName: 'procedure-name-column',
    formatter: a => (a ? a.office_email : ''),
    sortField: 'applicant.office_email',
  },
];
